<template>
  <article
    v-if="element"
    :class="['collapsible-article', { active: element.expanded }]"
  >
    <header class="header background-gray" @click="expanded()">
      <div
        class="article-icon has-text-centered is-size-1 has-text-grey custom-notification"
      ></div>
      <div class="article-title pl-2 pr-1">
        <p>
          <span v-if="element.subject.length <= 20">{{ element.subject }}</span>
          <span v-if="element.subject.length > 20">
            {{ element.subject.substring(0, 20) + "..." }}
          </span>
          <span class="unread" v-if="element.read_status == 'unread'">
            {{ $t("page.labels.unread") }}
          </span>
        </p>
        <p>
          <b>{{ $t("page.labels.personal_notification") }}</b>
        </p>
      </div>
      <div class="arrow"></div>
    </header>
    <div class="body article-body pa-2" v-if="element.expanded">
      <p class="mb-2">
        <b>{{ element.subject }}</b>
      </p>

      <p>{{ element.body }}</p>

      <div class="mt-3">
        <router-link
          :to="{
            name: 'enquiry-chat',
            params: { enquiryId: element.entity.id },
          }"
        >
          <span class="button is-outlined back-white">
            {{ $t("page.labels.see_message") }}
          </span>
        </router-link>
      </div>
    </div>
  </article>
</template>
<script>
export default {
  name: "NotificationEnquiryCommentCard",
  props: ["element"],
  methods: {
    expanded() {
      this.element.expanded = !this.element.expanded
      this.$emit("expanded", this.element)
    },
  },
}
</script>
